const productSelector = 'product-info[data-product-id="9121003405383"]';

function setupGelProduct(root = document) {
  const products = root.matches?.(productSelector) ? [root] : root.querySelectorAll(productSelector);
  for (const productInfo of products) {
    const configElement = productInfo.querySelector('[data-gel-ui-config]');
    const gallery = productInfo.querySelector('media-gallery');
    if (!configElement || !gallery || gallery.dataset.gelStableOrder === 'true') continue;
    let config;
    try { config = JSON.parse(configElement.textContent); } catch { continue; }
    const positions = new Map(config.mediaOrder.map((id, index) => [String(id), index]));
    const reorder = () => {
      for (const selector of ['[id^="Slider-Gallery-"]', '[id^="Slider-Thumbnails-"]']) {
        const list = gallery.querySelector(selector);
        if (!list) continue;
        const items = [...list.children];
        const key = (item) => (item.dataset.mediaId || item.dataset.target || '').split('-').pop();
        const ordered = [...items].sort((a, b) => (positions.get(key(a)) ?? Infinity) - (positions.get(key(b)) ?? Infinity));
        if (ordered.some((item, index) => item !== items[index])) {
          list.append(...ordered);
          list.closest('slider-component')?.resetPages?.();
        }
      }
    };
    gallery.dataset.preserveMediaOrder = 'true';
    gallery.dataset.gelStableOrder = 'true';
    const nativeSetActiveMedia = gallery.setActiveMedia.bind(gallery);
    gallery.setActiveMedia = (mediaId) => {
      reorder();
      return nativeSetActiveMedia(mediaId, false);
    };
    gallery.setActiveMedia(`${productInfo.dataset.section}-${config.initialMediaId}`);

  }
}

customElements.whenDefined('media-gallery').then(() => {
  setupGelProduct();
  document.addEventListener('shopify:section:load', (event) => setupGelProduct(event.target));
});
